import React from 'react';

import TITVDailyShow from '@components/TITVDailyShow';

import type { TITVNetwork } from '../Network/interfaces';
import { DAILY_SHOW_TITLE } from './constants';

interface TITVMultistreamFeatureHeroDescriptionProps {
  isInProgressStream?: boolean;
  titvNetwork?: TITVNetwork;
}

const TITVMultistreamFeatureHeroDescription = ({
  isInProgressStream,
  titvNetwork,
}: TITVMultistreamFeatureHeroDescriptionProps) => {
  if (!titvNetwork) {
    return null;
  }

  const Heading = isInProgressStream ? 'h2' : 'h1';

  return (
    <header className="mt-32 flex flex-wrap items-center justify-center gap-20 border-0 border-solid border-grayscale-beige sm:flex-nowrap sm:justify-between sm:border-t sm:pt-32 lg:mb-16 lg:mt-0 lg:border-b lg:border-t-0 lg:pb-16 lg:pt-0">
      <div className="flex w-full flex-col gap-12">
        <span className="block font-suisse-intl-mono text-overline-md font-normal">
          {titvNetwork.frequency}
        </span>
        <Heading
          className="m-0 font-suisse-screen text-headline-alt-sm sm:text-headline-alt-md lg:text-headline-alt-lg"
          title={titvNetwork.title}
        >
          {titvNetwork.title === DAILY_SHOW_TITLE ? <TITVDailyShow /> : titvNetwork.title}
        </Heading>
        <p className="mb-0 mt-3 max-w-full font-noto-serif text-body-lg font-normal text-grayscale-charcoal">
          {titvNetwork.description}
        </p>
      </div>
    </header>
  );
};

export default TITVMultistreamFeatureHeroDescription;
